import { Tabs } from "antd";
import QRScanner from "component/qr_scanner/qr_scan";
import QRUpload from "component/qr_scanner/qr_upload";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const SupporterScanTab = () => {
  // -------------------------- VAR -----------------------------
  const items = [
    {
      label: "Scan QR Nhân Viên",
      key: "qr",
      children: <QRScanner />,
    },
    {
      label: "Tải ảnh QR",
      key: "upload",
      children: <QRUpload />,
    },
  ];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <Tabs style={{ alignItems: "center", width: "100%" }} items={items} />;
};
export default SupporterScanTab;
